export default "__VITE_ASSET__1c710e21__"